import { NavLink } from "react-router-dom";
import './ClientsContent.css'

export default function ClientsContent(){
    return(
        <div className="clients-content">
            <div className="clients-heading">
                <h2>We are proud to be in partnership with the following clients:</h2>
                <p>
                    <a href="https://tdsltd.com/"target='_blank' rel="noopener noreferrer">Tyldesley Distribution Services</a>
                </p>
            </div>
            <div className="clients-enquiry">
                <h2>Interested in finding yourself on this page? Contact us now!</h2>
                <div className="the-button"><NavLink to='/Contact'>Contact us</NavLink></div>
                <p>You can view our Customer Terms and Conditions <a href="/Terms-and-Conditions">here.</a></p>
            </div>
        </div>
    )
}